import React from 'react'
import * as styles from './Tag.css'
import Text from '../text'

// color accepts only hsl values
export const Tag = ({ icon, text, color }) => {
  const luminosityChanger = (hsl, luminosity) => {
    return hsl
      .split(',')
      .map((entry, index) => {
        if (index === 2) {
          return ` ${luminosity}%`
        } else return entry
      })
      .join(',')
  }

  const bgColor = luminosityChanger(color, '95')
  const borderColor = luminosityChanger(color, '80')

  return (
    <div className={styles.tag} style={{ backgroundColor: bgColor, borderColor: borderColor }}>
      {icon}
      <Text size='0.9' color={color}>
        {text}
      </Text>
    </div>
  )
}
